import MobileNavigation from './includes/MobileNavigation';
import LanguageSelector from './includes/LanguageSelector';

new LanguageSelector();
new MobileNavigation();

document.querySelector('.print-button')?.addEventListener('click', () => {
	window.print();
});
